// Rodapé discreto com a versão publicada. A versão vem do package.json,
// injetada pelo Vite no build (`__APP_VERSION__`) — igual ao b2c-next.
export default function VersionFooter() {
  return (
    <footer className="version-footer">
      <span>v{__APP_VERSION__}</span>
    </footer>
  );
}
